// import { lazy } from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// const AppRoute = () => {
//   const Module = lazy(() => import("../modules"));
//   const Failed = lazy(() => import("../components/failed"));
//   const Success = lazy(() => import("../components/success"));
//   const InvoiceDataPage = lazy(() => import("../modules/module1/invoiceData"));
//   const NotFoundPage = lazy(() => import("../components/notfound"));
//   return (
//     <Router>
//       <Routes>
//         <Route path="/:dynamicData" element={<Module />} />
//         <Route path="/:dynamicData/failed" element={<Failed />} />
//         <Route path="/:dynamicData/success" element={<Success />} />
//         <Route path="/failed" element={<Failed />} />
//         <Route path="/success" element={<Success />} />
//         <Route path="/invoice/:dynamicData" element={<InvoiceDataPage />} />
//         <Route path="*" element={<NotFoundPage />} />
//       </Routes>
//     </Router>
//   );
// };

// export default AppRoute;

import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SkeletonColor from "../components/skeleton";

const Module = lazy(() => import("../modules"));
const Failed = lazy(() => import("../components/failed"));
const Success = lazy(() => import("../components/success"));
const InvoiceDataPage = lazy(() => import("../modules/module1/invoiceData"));
const NotFoundPage = lazy(() => import("../components/notfound"));

const AppRoute = () => {
  return (
    <Router>
      <Suspense fallback={<SkeletonColor />}>
        <Routes>
          {/* More specific routes */}
          <Route path="/invoice/:dynamicData" element={<InvoiceDataPage />} />
          <Route path="/:dynamicData/failed" element={<Failed />} />
          <Route path="/:dynamicData/success" element={<Success />} />
          <Route path="/failed" element={<Failed />} />
          <Route path="/success" element={<Success />} />

          {/* Dynamic route */}
          <Route path="/:dynamicData" element={<Module />} />

          {/* Fallback (404) route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRoute;
